import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-catalog-empty-state',
  templateUrl: './catalog-empty-state.component.html'
})
export class CatalogEmptyStateComponent {
  @Input() state: 'no-company' | 'no-catalog' = 'no-company';
  @Output() importClicked = new EventEmitter<void>();
  @Output() manualClicked = new EventEmitter<void>();
}
